module.exports = __webpack_public_path__ + "static/img/farm.bed6f326.png";